import { api } from '@/lib/axios';

export interface SampleRecordStatus {
  id: number;
  name: string;
}

export const fetchSampleRecordStatuses = async (): Promise<SampleRecordStatus[]> => {
  try {
    const { data } = await api.get<SampleRecordStatus[]>('/api/sample-record-statuses');
    return data;
  } catch (error) {
    console.error('Error fetching sample record statuses:', error);
    throw new Error('Error al cargar los estados de muestra');
  }
}; 